import { Box, Chip, TextField } from '@material-ui/core';
import { AutocompleteProps } from '@material-ui/lab';
import { AutocompleteStyled } from '@src/components/CustomMaterialUI/AutocompleteStyled';
import { primary } from '@src/muithemes/b2ChatTheme';
import './TagsSelect.style.css';

export type TagsSelectProps<
  T,
  Multiple extends boolean = boolean,
  DisableClearable extends boolean = boolean,
  FreeSolo extends boolean = boolean
> = Omit<
  AutocompleteProps<T, Multiple, DisableClearable, FreeSolo>,
  'renderInput'
> & {
  options: T[];
  value: T[];
  inputLabel: string;
  getTagOption: (item: T) => TagItem;
};

type TagItem = {
  id: number | string;
  color?: string;
  label: string;
  emoji?: string;
};

function TagsSelect<T>({
  options,
  value = [],
  onChange,
  inputLabel,
  getTagOption,
}: TagsSelectProps<T>) {
  return (
    <AutocompleteStyled
      multiple
      value={value}
      options={options}
      onChange={onChange}
      disabled={options.length === 0}
      getOptionLabel={tag => getTagOption(tag).label}
      getOptionSelected={selectedItem => {
        const selectedItemId = getTagOption(selectedItem).id;
        return value.some(
          item => getTagOption(item as T).id === selectedItemId
        );
      }}
      renderInput={params => (
        <TextField {...params} variant="outlined" label={inputLabel} />
      )}
      renderTags={(tagsValue, getTagProps) => (
        <>
          {tagsValue.slice(0, 3).map((tag, index) => {
            const { label, color, emoji } = getTagOption(tag);
            return (
              <Chip
                key={label}
                {...getTagProps({ index })}
                label={emoji}
                className="tags-chip"
                style={{ backgroundColor: color, color: 'rgba(0,0,0,0.87)' }}
              />
            );
          })}
          {tagsValue.length > 3 && (
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              style={{
                height: 18.5,
                maxWidth: 28,
                minWidth: 28,
                marginLeft: 3,
                fontWeight: 600,
                fontSize: '.8rem',
                borderRadius: 100,
                cursor: 'default',
                backgroundColor: primary.main,
                color: '#fff',
              }}
            >
              +{tagsValue.slice(3).length}
            </Box>
          )}
        </>
      )}
    />
  );
}

export default TagsSelect;
